export const Routes = {
  landing: { path: '/' },
  mate: { path: '/m/mate' },
  mateVerify: { path: '/m/mate-verify' },
  checkout: {
    path: '/checkout',
    secured: true,
  },
  checkoutConfirmation: {
    path: '/checkout-confirmation',
    secured: true,
  },
  modifySubscription: {
    path: '/modify-subscription',
    secured: true,
  },
  invoiceAppQrCode: { path: '/m/invoice-app-qr-code' },
} as const;

export type PortalRoutePathname = typeof Routes[keyof typeof Routes]['path'];

export function normaliseRoutePath(path: string) {
  const pathname = new URL(path, 'http://localhost').pathname;

  if (pathname === '/') {
    return pathname;
  }

  return pathname.endsWith('/') ? pathname.slice(0, -1) : pathname;
}

export function matchesRoutePath(routePath: string, currentPath: string) {
  return normaliseRoutePath(routePath) === normaliseRoutePath(currentPath);
}

export function getPortalRoutePath(
  path: string
): PortalRoutePathname | undefined {
  return Object.values(Routes).find((route) => {
    return matchesRoutePath(route.path, path);
  })?.path;
}
